import { post } from "@utils/httpUtil";

// 分页查询运营课堂
export function pageOperationCourse(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/operate/course/pageOperationCourse`, data, config);
}

// 获取常用功能菜单
export function getCommonFunctionMenu(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/sysmenu/getCommonFunctionMenu", data, config);
}

// 保存登录客户常用功能菜单
export function saveUserCommonFunctionMenu(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/sysmenu/saveUserCommonFunctionMenu", data, config);
}

// 获取登录客户常用功能菜单
export function getUserCommonFunctionMenu(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/sysmenu/getUserCommonFunctionMenu", data, config);
}

// 公告列表
export function announcementPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/homePage/announcementPageList`, data, config);
}

// 获取社区我的待办数据
export function getCommunityMyTodoTasksData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/getCommunityMyTodoTasksData`, data, config);
}

// 公告详情
export function announcementDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/homePage/announcementDetail`, data, config);
}
// 获取弹窗广告数据
export function getPopUpAdsData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/homePage/getPopUpAdsData`, data, config);
}
// 获取Banner数据
export function getBannerData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/homePage/getBannerData`, data, config);
}
